import { V3Routes } from '../../routes';
import {
  ADVERTISING_OPERATION_COURSE_ID,
  BRANDING_COURSE_ID,
  BUSINESS_COURSE_ID,
  CAMERA_COURSE_ID,
  CONTENTS_MARKETING_COURSE_ID,
  COPY_WRITING_COURSE_ID,
  DESIGN_EXERCISE_COURSE_Id,
  DIRECTOR_COURSE_ID,
  FREELANCE_COURSE_ID,
  ILLUSTRATOR_COURSE_ID,
  LOGO_CI_COURSE_ID,
  MARKETING_FIRST_COURSE_ID,
  PR_COURSE_ID,
  PROJECT_MANAGEMENT_COURSE_ID,
  SELF_BRANDING_COURSE_ID,
  SNS_MARKETING_COURSE_ID,
  UI_UX_COURSE_ID,
  WEB_DESIGN_COURSE_ID,
  WEB_DESIGN_FIRST_COURSE_ID,
  WEB_MARKETING_COURSE_ID,
  WEB_WRITING_COURSE_ID,
  WORDPRESS_COURSE_ID,
  WORK_TRIAL_COURSE_ID,
  WRITING_FIRST_COURSE_ID,
} from '../../types/courses';
import React from 'react';
import CourseWebDesignFirst from './images/course-webdesign-first.png';
import CourseWebDesign from './images/course-webdesign.png';
import CourseSmallDesignExercise from './images/course-small-design-exercise.png';
import CourseSmallIllustrator from './images/course-small-illustrator.png';
import CourseSmallWordPress from './images/course-small-wordpress.png';
import CourseSmallLogoCI from './images/course-small-logo-ci.png';
import CourseSmallUIUX from './images/course-small-ui-ux.png';
import CourseSmallBranding from './images/course-small-branding.png';
import CourseSmallDirector from './images/course-small-director.png';
import CourseSmallProjectManagement from './images/course-small-project-management.png';
import CourseSmallBusiness from './images/course-small-business.png';
import CourseMarketingFirst from './images/course-marketing-first.png';
import CourseWebMarketing from './images/course-web-marketing.png';
import CourseWritingFirst from './images/course-writing-first.png';
import CourseWebWriting from './images/course-web-writing.png';
import CourseSmallCopyWriting from './images/course-small-copy-writing.png';
import CourseSmallAdvertisingOperation from './images/course-small-advertising-operation.png';
import CourseSmallPr from './images/course-small-pr.png';
import CourseSmallSelfBranding from './images/course-small-self-branding.png';
import CourseSmallMarketingFirst from './images/course-small-marketing-first.png';
import CourseSmallWebMarketing from './images/course-small-web-marketing.png';
import CourseSmallSnsMarketing from './images/course-small-sns-marketing.png';
import CourseSmallCamera from './images/course-small-camera.png';
import CourseSmallFreelance from './images/course-small-freelance.png';
import CourseSmallContentsMarketing from './images/course-small-contents-marketing.png';
import CourseSmallWorkTrial from './images/course-small-work-trial.png';
import './courseCard.module.scss';

export const CourseWebDesignFirstCard = () => (
  <a href={V3Routes.course(WEB_DESIGN_FIRST_COURSE_ID).stringify()}>
    <img src={CourseWebDesignFirst} styleName="main-course-card" />
  </a>
);

export const CourseWebDesignCard = () => (
  <a href={V3Routes.course(WEB_DESIGN_COURSE_ID).stringify()}>
    <img src={CourseWebDesign} styleName="main-course-card" />
  </a>
);

export const CourseMarketingFirstCard = () => (
  <a href={V3Routes.course(MARKETING_FIRST_COURSE_ID).stringify()}>
    <img src={CourseMarketingFirst} styleName="main-course-card" />
  </a>
);

export const CourseWebMarketingCard = () => (
  <a href={V3Routes.course(WEB_MARKETING_COURSE_ID).stringify()}>
    <img src={CourseWebMarketing} styleName="main-course-card" />
  </a>
);

export const CourseWritingFirstCard = () => (
  <a href={V3Routes.course(WRITING_FIRST_COURSE_ID).stringify()}>
    <img src={CourseWritingFirst} styleName="main-course-card" />
  </a>
);

export const CourseWebWritingCard = () => (
  <a href={V3Routes.course(WEB_WRITING_COURSE_ID).stringify()}>
    <img src={CourseWebWriting} styleName="main-course-card" />
  </a>
);

export const CourseSmallDesignExerciseCard = () => (
  <a href={V3Routes.course(DESIGN_EXERCISE_COURSE_Id).stringify()} styleName="small-course-card">
    <img src={CourseSmallDesignExercise} />
  </a>
);

export const CourseSmallIllustratorCard = () => (
  <a href={V3Routes.course(ILLUSTRATOR_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallIllustrator} />
  </a>
);

export const CourseSmallWordPressCard = () => (
  <a href={V3Routes.course(WORDPRESS_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallWordPress} />
  </a>
);

export const CourseSmallLogoCICard = () => (
  <a href={V3Routes.course(LOGO_CI_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallLogoCI} />
  </a>
);

export const CourseSmallUIUXCard = () => (
  <a href={V3Routes.course(UI_UX_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallUIUX} />
  </a>
);

export const CourseSmallBrandingCard = () => (
  <a href={V3Routes.course(BRANDING_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallBranding} />
  </a>
);

export const CourseSmallDirectorCard = () => (
  <a href={V3Routes.course(DIRECTOR_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallDirector} />
  </a>
);

export const CourseSmallProjectManagementCard = () => (
  <a href={V3Routes.course(PROJECT_MANAGEMENT_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallProjectManagement} />
  </a>
);

export const CourseSmallBusinessCard = () => (
  <a href={V3Routes.course(BUSINESS_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallBusiness} />
  </a>
);

export const CourseSmallCopyWritingCard = () => (
  <a href={V3Routes.course(COPY_WRITING_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallCopyWriting} />
  </a>
);

export const CourseSmallAdvertisingOperationCard = () => (
  <a href={V3Routes.course(ADVERTISING_OPERATION_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallAdvertisingOperation} />
  </a>
);

export const CourseSmallPrCard = () => (
  <a href={V3Routes.course(PR_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallPr} />
  </a>
);

export const CourseSmallSelfBrandingCard = () => (
  <a href={V3Routes.course(SELF_BRANDING_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallSelfBranding} />
  </a>
);

export const CourseSmallMarketingFirstCard = () => (
  <a href={V3Routes.course(MARKETING_FIRST_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallMarketingFirst} />
  </a>
);

export const CourseSmallWebMarketingCard = () => (
  <a href={V3Routes.course(WEB_MARKETING_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallWebMarketing} />
  </a>
);

export const CourseSmallSnsMarketingCard = () => (
  <a href={V3Routes.course(SNS_MARKETING_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallSnsMarketing} />
  </a>
);

export const CourseSmallCameraCard = () => (
  <a href={V3Routes.course(CAMERA_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallCamera} />
  </a>
);

export const CourseSmallFreelanceCard = () => (
  <a href={V3Routes.course(FREELANCE_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallFreelance} />
  </a>
);

export const CourseSmallContentsMarketingCard = () => (
  <a href={V3Routes.course(CONTENTS_MARKETING_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallContentsMarketing} />
  </a>
);

export const CourseSmallWorkTrialCard = () => (
  <a href={V3Routes.course(WORK_TRIAL_COURSE_ID).stringify()} styleName="small-course-card">
    <img src={CourseSmallWorkTrial} />
  </a>
);
